import { render, staticRenderFns } from "./chemLawHistoryDetail.vue?vue&type=template&id=36763cba"
import script from "./chemLawHistoryDetail.vue?vue&type=script&lang=js"
export * from "./chemLawHistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./chemLawHistoryDetail.vue?vue&type=style&index=0&id=36763cba&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36763cba')) {
      api.createRecord('36763cba', component.options)
    } else {
      api.reload('36763cba', component.options)
    }
    module.hot.accept("./chemLawHistoryDetail.vue?vue&type=template&id=36763cba", function () {
      api.rerender('36763cba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemLawHistoryDetail.vue"
export default component.exports